import { render, staticRenderFns } from "./medsos_tren_mention_sources.vue?vue&type=template&id=0622c22c"
import script from "./medsos_tren_mention_sources.vue?vue&type=script&lang=js"
export * from "./medsos_tren_mention_sources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports